import Vue from 'vue'
// import "babel-polyfill";
import App from './App.vue'
import router from './router'
import './assets/css/base.css'
import {
    Option,
    Select,
    Input,
    Breadcrumb,
    BreadcrumbItem,
    Pagination,
    Loading,
    Message,
    Dialog,
    Menu,
    MenuItemGroup,
    submenu,
    MenuItem
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
    api
} from "@/require/api.js";
import store from "./store";
import {
    VueJsonp
} from 'vue-jsonp'
import mixinWidth from "./mixins/index"
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.mixin(mixinWidth)
Vue.use(VueJsonp)
Vue.use(Option)
Vue.use(Select)
Vue.use(Input)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Pagination)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Menu);
Vue.use(MenuItemGroup);
Vue.use(submenu);
Vue.use(MenuItem);
Vue.prototype.$message = Message;
Vue.config.productionTip = false
Vue.prototype.$api = api
    // 公共组件
const Top = () =>
    import ("@/components/Top");
Vue.component("Top", Top)
const Footer = () =>
    import ("@/components/Footer");
Vue.component("Footer", Footer)

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#App')